export enum BusinessRulesTypeEnum {
  EOP_LENGTH = 'eop_length',
  MAX_PRICE_DROP = 'max_price_drop',
  MIN_PRICE_GROWTH = 'min_price_growth',
  MAX_WINBACK_INACTIVE_LENGTH = 'max_winback_inactive_length',
  BLOCK_WINBACK = 'block_winback',
  BLOCK_CUSTOMER_IN_DEBT = 'block_customer_in_debt',
  BLOCK_MIGRATION_ON_DISCOUNT_PERIOD_START = 'block_migration_on_discount_period_start',
  BLOCK_MIGRATION = 'block_migration',
  BLOCK_OFFER_WITH_LOWER_RANK_MAIN_SERVICES = 'block_offer_with_lower_rank_main_services',
  BLOCK_OFFER_WITH_SHORTER_COMMITMENT_LENGTH = 'block_offer_with_shorter_commitment_length',
  BLOCK_OFFER_WITH_OWNED_SERVICES = 'block_offer_with_owned_services',
  BLOCK_OFFER_WITH_PREMIUMS_WITH_START_DISCOUNT_MONTHS = 'block_offer_with_premiums_with_start_discount_months',
  BLOCK_OFFER_WITH_NOT_CONFIGURED_PRODUCTS = 'block_offer_with_not_configured_products',
  MIN_PRICE_GROWTH_SOLO_CUSTOMER = 'min_price_growth_solo_customer'
}



// WEBPACK FOOTER //
// ./src/app/enums/businessRulesTypes.enum.ts